import React from 'react'
import GradientHeaderWithIntro from 'components/shared/GradientHeaderWithIntro'
import Iframe from 'components/shared/Iframe'
import { formatYoutubeUrl } from 'services/helpers'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const LargeVideo = ({ className, url, darkMode, size, ...rest }) => {
  const formattedYoutubeUrl = formatYoutubeUrl(url)

  return (
    <GradientHeaderWithIntro
      className={cx(className, darkMode ? css.SmallMargin : '')}
      headerChildren={() => (
        <div className={cx(css.videoWrapper, size, { darkMode })}>
          <Iframe className={darkMode ? css.iframeDarkMode : ''}>
            <iframe src={formattedYoutubeUrl} data-cookieconsent="marketing" loading="lazy"/>
          </Iframe>
        </div>
      )}
      {...rest}
    />
  )
}

LargeVideo.defaultProps = {
  size: 'large',
  darkMode: 'false',
}

export default LargeVideo
